import {
  DetailType,
  HandballAttributeId,
  HandballFoulAttribute,
  HandballGoalAttribute,
  HandballIncidentId,
  HandballMissedThrowAttribute,
  HandballTurnoverAttribute,
} from '@collector/sportsapi-client-legacy'
import {
  SportAttributesConfiguration,
  SportDetailsConfiguration,
} from '@mobile/views/Relation/DetailsPanel/Sports/composables/useSportOptions'

import GoalDetailsModal from './Modals/GoalDetailsModal/GoalDetailsModal.vue'
import { getIncidentDetailsFillState as goalIncidentValidator } from './Modals/GoalDetailsModal/utils'
import MissedThrowDetailsModal from './Modals/MissedThrowDetailsModal/MissedThrowDetailsModal.vue'
import { getIncidentDetailsFillState as missedThrowIncidentValidator } from './Modals/MissedThrowDetailsModal/utils'
import PenaltySavedDetailsModal from './Modals/PenaltySavedDetailsModal/PenaltySavedDetailsModal.vue'
import { getIncidentDetailsFillState as penaltySavedIncidentValidator } from './Modals/PenaltySavedDetailsModal/utils'
import ThrowBlockedDetailsModal from './Modals/ThrowBlockedModal/ThrowBlockedModal.vue'
import { getIncidentDetailsFillState as throwBlockedIncidentValidator } from './Modals/ThrowBlockedModal/utils'
import ThrowSavedDetailsModal from './Modals/ThrowSavedDetailsModal/ThrowSavedDetailsModal.vue'
import { getIncidentDetailsFillState as throwSavedIncidentValidator } from './Modals/ThrowSavedDetailsModal/utils'

export enum HandballGroupNames {
  Type = 'Type',
}

export const HandballDetailsConfiguration: SportDetailsConfiguration<
  HandballIncidentId,
  HandballAttributeId
> = {
  [HandballIncidentId.Goal]: {
    component: GoalDetailsModal,
    getIncidentDetailsFillState: goalIncidentValidator,
  },
  [HandballIncidentId.MissedThrow]: {
    component: MissedThrowDetailsModal,
    getIncidentDetailsFillState: missedThrowIncidentValidator,
  },
  [HandballIncidentId.ThrowBlocked]: {
    component: ThrowBlockedDetailsModal,
    getIncidentDetailsFillState: throwBlockedIncidentValidator,
  },
  [HandballIncidentId.ThrowSaved]: {
    component: ThrowSavedDetailsModal,
    getIncidentDetailsFillState: throwSavedIncidentValidator,
  },
  [HandballIncidentId.PenaltySaved]: {
    component: PenaltySavedDetailsModal,
    getIncidentDetailsFillState: penaltySavedIncidentValidator,
  },
  [HandballIncidentId.Turnover]: [
    {
      name: HandballGroupNames.Type,
      attributes: [
        HandballTurnoverAttribute.Traveling,
        HandballTurnoverAttribute.SteppingTheLine,
      ],
      cols: 2,
      important: false,
      multiple: false,
      type: DetailType.Button,
    },
  ],
  [HandballIncidentId.Foul]: [
    {
      name: HandballGroupNames.Type,
      attributes: [
        HandballFoulAttribute.OffensiveFoul,
        HandballFoulAttribute.DefenceInGoalArea,
        HandballFoulAttribute.CausesPenalty,
      ],
      cols: 3,
      important: false,
      multiple: false,
      type: DetailType.Button,
    },
  ],
}

export const HandballAttributesConfiguration: SportAttributesConfiguration<
  HandballIncidentId,
  HandballAttributeId
> = {
  [HandballIncidentId.Goal]: [HandballGoalAttribute.PenaltyGoal],
  [HandballIncidentId.MissedThrow]: [
    HandballMissedThrowAttribute.ThrowWoodwork,
  ],
  [HandballIncidentId.Turnover]: [
    HandballTurnoverAttribute.SteppingTheLine,
    HandballTurnoverAttribute.Traveling,
  ],
}
